/* eslint-disable */
/* eslint-disable sonarjs/no-duplicate-string */
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Icon,
  makeStyles,
  RACCheckBox,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACTextField,
} from '@rentacenter/racstrap';
import { CancelTokenSource } from 'axios';
import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { getCancelTokenSource } from '../../api/client';
import { getPurchaseOrders } from '../../api/purchaseOrders';
import {
  GetPurchaseOrderRequest,
  GetPurchaseOrderResponse,
  PurchaseOrder,
  UpdatedPOInformation,
  PurchaseOrderDetail,
} from '../../types/types';
import {
  formatDateString,
  formatMoney,
  getPONumber,
  getSelectedStore,
} from '../../utils/utils';
import {
  handlePartialRefusalSubmitted,
  ReceivedDetailRow,
  trimTextWithTooltip,
  POListProps,
} from './RegularPOList';
import {
  INITIAL_OFFSET,
  POSection,
  RcvdRegAndMPOTypes,
  RECEIVING_PO_API_LIMIT,
} from '../../constants/constants';
import { ReceiveNowActions } from './ReceiveNowActions';
import { ApiStateWrapper } from '../../common/ApiStateWrapper/ApiStateWrapper';
import { useGlobalContext } from '../../context/global/GlobalContext';
import {
  setPreviouslyReceived,
  setSelectedPreviouslyReceivedId,
  setUpdatedItemsData,
} from '../../context/global/reducer/previouslyReceivedActions';
import {
  useSearchActions,
  useSearchDetails,
} from '../../context/Search/SearchProvider';
import { FieldWithTooltip } from '../../common/FieldWithTooltip/FieldWithTooltip';
import { AutoNumeric } from '../../common/AutoNumeric/AutoNumeric';
import {
  setSelectedPOToReceive,
  setUpdatedPOData,
} from '../../context/global/reducer/selectedPOToReceiveActions';
import { setSelectedPORev } from '../../context/global/reducer/selectedPORevActions';
import { useTranslation } from 'react-i18next';
import { getTotalPOItems } from './RegularPOList';

export const previouslyReceivedPOListTestId = 'previouslyReceivedPOListTestId';

const useClasses = makeStyles((theme: any) => ({
  purchaseOrderListWrapper: {
    width: '100%',
    height: theme.typography.pxToRem(290),
  },
  purchaseOrderList: {
    flexDirection: 'row',
    boxSizing: 'border-box',
    borderRadius: '1rem',
    overflowX: 'auto',
    height: theme.typography.pxToRem(290),
  },
  paddingTopBottom8: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
  },
  contentHeight: {
    height: theme.typography.pxToRem(233),
  },
  mainTableCell: {
    fontWeight: 'bolder',
    fontSize: '1rem',
  },
  childTableCellWidth50: {
    width: theme.typography.pxToRem(50),
  },
  childTableCellWidth130: {
    width: theme.typography.pxToRem(130),
  },
  childTableCellWidth33: {
    width: '33px',
    minWidth: '33px',
  },
  childTableCellWidth100: {
    width: theme.typography.pxToRem(100),
  },
  childTableCellWidth150: {
    width: theme.typography.pxToRem(150),
  },
  childTableCellWidth250: {
    width: theme.typography.pxToRem(250),
  },
  childTableCellWidth: {
    width: theme.typography.pxToRem(180),
  },
  mainCheckbox: {
    width: `${theme.typography.pxToRem(40)} !important`,
  },
  disabled: {
    opacity: '.5',
  },
  checkboxChecked: {
    display: 'flex',
  },
  checkbox: {
    padding: '0',
    width: theme.typography.pxToRem(120),
    height: theme.typography.pxToRem(50),
    '& svg': {
      width: theme.typography.pxToRem(26),
      height: theme.typography.pxToRem(26),
    },
  },
  receivedDetailContainer: {
    display: 'inline-flex',
    marginLeft: '10%',
    fontSize: theme.typography.pxToRem(14),
    width: '100%',
  },
  receivedDetailLabel: {
    fontWeight: 'bolder',
  },
  receivedDetailValue: {
    fontSize: theme.typography.pxToRem(14),
  },
  receivedDetailItem: {
    width: theme.typography.pxToRem(200),
    marginRight: '5%',
  },
  minWidth150: {
    width: '150px',
    minWidth: '150px',
  },
  receivedDetailComment: {
    width: '100%',
    maxWidth: theme.typography.pxToRem(300),
    marginRight: '5%',
  },
  field: {
    width: '12rem',
    '& input': {
      height: theme.typography.pxToRem(25),
    },
  },
  tableHeader: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    backgroundColor: 'white',
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '6%',
  },
  icon: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontSize: theme.typography.pxToRem(20),
    height: '100%',
  },
  fieldFlex: {
    display: 'flex',
    justifyContent: 'end',
    width: theme.typography.pxToRem(10),
  },
  mainTableCellWrapper: {
    display: 'flex',
  },
  mainTableCellWidth116: {
    width: theme.typography.pxToRem(116),
  },
  fieldWidth70percent: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '50%',
    minWidth: theme.typography.pxToRem(600),
  },
  fixedFieldContainer:{},
  '@media (max-width: 800px)': {
    fixedFieldContainer: {
    position: 'sticky', 
    top: 0, // Stick to the top of the viewport
    backgroundColor: 'white', // Background color for visibility
    zIndex: 10, // Ensure it stays above other content
    display: 'flex', // Use flexbox to align items
    padding: theme.typography.pxToRem(10), // Add some padding
    marginLeft:'-5%',
  },
  purchaseOrderListWrapper: {
    width: '100%',
    height: theme.typography.pxToRem(290),
    overflowY: 'auto', // Allow vertical scrolling
  },
  purchaseOrderList: {
    flexDirection: 'column', // Change to column to stack elements
    boxSizing: 'border-box',
    borderRadius: '1rem',
    overflowX: 'hidden', // Prevent horizontal scrolling
    height: 'auto', // Allow height to adjust based on content
  },
  scrollableContent: {
    overflowY: 'auto', // Enable vertical scrolling for this section
    maxHeight: `calc(290px - ${theme.typography.pxToRem(50)})`, // Adjust height based on fixed header size
  },

     childTableCellWidth250: {
    width: theme.typography.pxToRem(250),
  },
    tableHeader: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    backgroundColor: 'white',
    width: theme.typography.pxToRem(125),
    minWidth: theme.typography.pxToRem(125),
  },
   field: {
    width: '12rem',
    marginRight:'-10%',
    '& input': {
      height: theme.typography.pxToRem(25),
    },
  },
  fieldWidth70percent: {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%', // Full width on smaller screens
  minWidth: theme.typography.pxToRem(600),
},
  }
}));

const generatePOReceivedForPreviouslyReceivedPO = (
  poReceivedDetails: PurchaseOrderDetail[]
) => {
  const flatPOReceivedDetails: any[] = [];

  poReceivedDetails.forEach((item) => {
    // if (item?.quantityOrdered !== item?.receivedCount) {
    //   const totalPONotReceived =
    //     item?.quantityOrdered - (item?.receivedCount || 0);
    //   for (let index = 0; index < totalPONotReceived; index++) {
    //     flatPOReceivedDetails.push(item);
    //   }
    // }

    if (item.purchaseOrderReceivedDetails?.length) {
      item.purchaseOrderReceivedDetails.forEach((detail) => {
        flatPOReceivedDetails.push({
          ...item,
          ...detail,
        });
      });
    }
  });
  return flatPOReceivedDetails;
};

export const PreviouslyReceivedPOList = ({ expanded }: POListProps) => {
  const initialCallToken = useRef<CancelTokenSource>();
  const [hasApiError, setApiHasError] = useState(false);
  // const [selectedPO, setSelectedPO] = useState('');
  const {
    dispatch,
    previouslyReceived: { data: purchaseOrders, selectedItemId: selectedPO },
  } = useGlobalContext();

  const [selectedReceivedDetailPO, setSelectedReceivedDetailPO] = useState<
    string[]
  >([]);
  const [loading, setLoading] = useState(false);
  const classes = useClasses();
  const isPurchaseOrdersEmpty = !purchaseOrders || purchaseOrders?.length === 0;
  const [partialReceivedPOs, setPartialReceivedPOs] = useState<
    UpdatedPOInformation[]
  >([]);
  const [revItems, setRevItems] = useState<UpdatedPOInformation[]>([]);
  const {
    setSearchedPOInSection,
    setPreviouslyReceivedPOLoading,
    setSearchItemFound,
  } = useSearchActions();
  const {
    filter,
    manualPOReceive,
    reloadData,
    queryParamsProp,
    oracleFusionEnableValue,
  } = useSearchDetails();
  const isOracleFusionEnabled = oracleFusionEnableValue === '1';
  const { poNumber, toDate, fromDate } = filter || {};
  const [vendorName, setVendorName] = useState('');
  const [totalCost, setTotalCost] = useState('');
  const [eta, setEta] = useState('');
  const { t } = useTranslation();

  const clearPOFields = () => {
    setVendorName('');
    setTotalCost('');
    setEta('');

    dispatch(setSelectedPORev({} as PurchaseOrder));
  };

  const onPOSelection = (po: PurchaseOrder) => {
    const poNumber = String(po.purchaseOrderNumber);
    const clearPo = selectedPO === poNumber;

    clearPo
      ? dispatch(setSelectedPreviouslyReceivedId(''))
      : dispatch(setSelectedPreviouslyReceivedId(poNumber));
    setPartialReceivedPOs([]);
    setRevItems([]);
    setSelectedReceivedDetailPO([]);
    if (clearPo) {
      clearPOFields();
    } else {
      po.vendorName && setVendorName(po.vendorName);
      setTotalCost(po.totalCost);
      po.estimatedDeliveryDate &&
        setEta(formatDateString(po.estimatedDeliveryDate));
      // dispatch(setSelectedPORev(po));
    }
  };

  const renderTableHead = () => (
    <>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth33),
        }}
      />
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.minWidth150),
        }}
      >
        {t('PO #')}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t('Item #')}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t('Model #')}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth250),
        }}
      >
        {t('Description')}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t('Brand')}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth100),
        }}
      >
        {t('Cost')}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t('Receiving Now')}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t('Serial #')}
      </RACTableCell>
      <RACTableCell
        classes={{
          root: clsx(classes.tableHeader, classes.childTableCellWidth150),
        }}
      >
        {t('Bol')}
      </RACTableCell>
    </>
  );

  const renderTableContent = () => {
    if (isPurchaseOrdersEmpty) return <></>;

    return renderTableContentFilled();
  };

  const renderTableContentFilled = () => (
    <>
      {purchaseOrders?.map((po, index) => {
        const poNumber = String(po.purchaseOrderNumber);
        const showPODetail = poNumber === selectedPO && po.purchaseOrderDetails;
        return (
          <RACTableRow key={index} backgroundColor="white">
            <>
              <RACTableCell
                classes={{
                  root: clsx(
                    classes.paddingTopBottom8,
                    classes.childTableCellWidth100
                  ),
                }}
                colSpan={10}
              >
                <div>
                  <RACCheckBox
                    id={String(po.purchaseOrderNumber)}
                    color="primary"
                    onChange={() => onPOSelection(po)}
                    checked={selectedPO === poNumber}
                    classes={{
                      checkbox: clsx(classes.checkbox, classes.mainCheckbox),
                    }}
                  />
                  <span
                    className={clsx(classes.mainTableCell, classes.minWidth150)}
                  >
                    {getPONumber(po)}
                  </span>
                </div>
                {showPODetail && (
                  <RACTable
                    renderTableHead={() => <></>}
                    renderTableContent={() =>
                      renderChildTableContent(
                        po.purchaseOrderId,
                        generatePOReceivedForPreviouslyReceivedPO(
                          po.purchaseOrderDetails
                        )
                      )
                    }
                  />
                )}
              </RACTableCell>
            </>
          </RACTableRow>
        );
      })}
    </>
  );

  const handleItemSelect = (
    purchaseOrderId: string,
    poReceived: any,
    isSelected: boolean,
    receivedId: any
  ) => {
    if (isSelected) {
      setSelectedReceivedDetailPO(
        selectedReceivedDetailPO.filter((item) => item !== receivedId)
      );
      setRevItems(
        revItems.filter(
          (item) =>
            item.purchaseOrderDetailReceivedId !==
            poReceived.purchaseOrderDetailReceivedId
        )
      );
    } else {
      setSelectedReceivedDetailPO([...selectedReceivedDetailPO, receivedId]);
      const newItem: UpdatedPOInformation = {
        purchaseOrderId,
        purchaseOrderDetailId: poReceived?.purchaseOrderDetailId,
        purchaseOrderDetailReceivedId:
          poReceived?.purchaseOrderDetailReceivedId,
        reversible: poReceived?.reversible ? true : false,
      };
      setRevItems([...revItems, newItem]);
    }
  };
  useEffect(() => {
    dispatch(setUpdatedItemsData(revItems));
  }, [revItems, dispatch]);

  const renderChildTableContent = (
    purchaseOrderId: string,
    poReceivedDetails: PurchaseOrderDetail[]
    // eslint-disable-next-line sonarjs/cognitive-complexity
  ) => (
    <>
      {poReceivedDetails
        ?.flatMap((i) => [i, i])
        .map((poReceived: any, index) => {
          const receivedId = `${purchaseOrderId}-${
            poReceived?.purchaseOrderDetailId
          }-${poReceived?.purchaseOrderDetailReceivedId || index}`;
          const previousReceivedIdRow = `${purchaseOrderId}-${
            poReceived?.purchaseOrderDetailId
          }-${poReceived?.purchaseOrderDetailReceivedId || index - 1}`;
          const isItemReceived = !!poReceived?.purchaseOrderDetailReceivedId;
          const isPreviouslyReceived =
            isItemReceived && !poReceived?.partialReasonId;
          // poReceived?.quantityOrdered === poReceived?.receivedCount;
          const isSelected = selectedReceivedDetailPO.includes(receivedId);
          const isPartial = !!poReceived?.partialReasonId;
          const isRevesible = poReceived?.reversible || false;
          if (index % 2 !== 0) {
            return (
              <ReceivedDetailRow
                key={index}
                index={index - 1}
                partialReceivedPO={partialReceivedPOs}
                poReceivedDetail={poReceived}
                isDisabled={
                  !selectedReceivedDetailPO.includes(previousReceivedIdRow)
                }
                isPartial={isPartial}
                isPreviouslyReceived={isPreviouslyReceived}
                dateReceivedColumnNeeded
              />
            );
          }

          return (
            <RACTableRow key={index} backgroundColor="white">
              <>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.checkbox,
                      classes.childTableCellWidth100
                    ),
                  }}
                >
                  <RACCheckBox
                    id={receivedId}
                    color="primary"
                    onChange={() =>
                      handleItemSelect(
                        purchaseOrderId,
                        poReceived,
                        isSelected,
                        receivedId
                      )
                    }
                    // onChange={() =>
                    //   isSelected
                    //     ? setSelectedReceivedDetailPO(
                    //       selectedReceivedDetailPO.filter(
                    //         (item) => item !== receivedId
                    //       )
                    //     )
                    //     : setSelectedReceivedDetailPO([
                    //       ...selectedReceivedDetailPO,
                    //       receivedId,
                    //     ])
                    // }
                    classes={{ checkbox: classes.checkbox }}
                    checked={isSelected}
                    disabled={!isRevesible}
                  />
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth50,
                      !isSelected && classes.disabled
                    ),
                  }}
                ></RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {poReceived?.inventoryNumber || ''}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {trimTextWithTooltip(poReceived?.modelNumber) || ''}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth250,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {trimTextWithTooltip(poReceived?.itemDescription) || ''}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {poReceived?.brand || ''}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth100,
                      !isSelected && classes.disabled
                    ),
                  }}
                >
                  {formatMoney(poReceived?.itemCost)}
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150
                    ),
                  }}
                >
                  <ReceiveNowActions
                    isDisabled
                    isPartialReceivingNowSelected={isPartial}
                    onPartialRefusalSubmitted={(reason, comment, action) =>
                      setPartialReceivedPOs(
                        handlePartialRefusalSubmitted(
                          purchaseOrderId,
                          reason,
                          comment,
                          poReceived,
                          index,
                          action,
                          partialReceivedPOs
                        )
                      )
                    }
                  />
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150
                    ),
                  }}
                >
                  <RACTextField
                    name={`serial-${receivedId}`}
                    value={poReceived?.manufacturerSerialNumber || ''}
                    type="text"
                    // eslint-disable-next-line no-console
                    onChange={() => console.log('Implement me!')}
                    disabled
                  />
                </RACTableCell>
                <RACTableCell
                  classes={{
                    root: clsx(
                      classes.paddingTopBottom8,
                      classes.childTableCellWidth150
                    ),
                  }}
                >
                  <RACTextField
                    name={`bol-${receivedId}`}
                    value={poReceived?.bol || ''}
                    type="text"
                    disabled
                  />
                </RACTableCell>
              </>
            </RACTableRow>
          );
        })}
    </>
  );

  const fetchPurchaseOrders = () => {
    if (manualPOReceive && queryParamsProp?.origin !== 'inventory') return;
    if (initialCallToken?.current) {
      initialCallToken.current?.cancel();
    }
    initialCallToken.current = getCancelTokenSource();

    setApiHasError(false);
    setLoading(true);
    const storeNumber = getSelectedStore();

    const request: GetPurchaseOrderRequest = {
      storeNumber: [storeNumber],
      showChargedOffInv: 'Y',
      purchaseOrderType: RcvdRegAndMPOTypes,
      poStatusType: isOracleFusionEnabled?['RCV', 'PRCV', 'APR']: ['RCV', 'PRCV'],
    };

    if (fromDate && toDate) {
      request.poDateRange = {
        endDate: toDate,
        startDate: fromDate,
      };
    }

    if (poNumber) {
      request.purchaseOrderNumber = poNumber;
      setSearchItemFound(false);
    }

    const shouldIncludePO = (po: PurchaseOrder) => {
      if (po?.poStatusType !== 'APR') {
        return true;
      }

      // APR belongs here only while the PO is still open (no close date).
      if (po?.closeDate !== null) {
        return false;
      }
      
      const { totalOrdered, totalCanceled, totalReceived } =
      getTotalPOItems(po.purchaseOrderDetails);
  
      const expected = Math.max(totalOrdered - totalCanceled, 0);
  
      const isFullyReceived = expected === totalReceived;

      const partiallyReceived = !isFullyReceived && totalReceived !== 0;

      return isFullyReceived || partiallyReceived;
    };

    getPurchaseOrders(
      request,
      INITIAL_OFFSET,
      RECEIVING_PO_API_LIMIT,
      initialCallToken.current?.token
    )
      .then((response: GetPurchaseOrderResponse) => {
        if (response?.purchaseOrders?.length) {
          const filteredPOs = isOracleFusionEnabled
            ? response.purchaseOrders.filter(shouldIncludePO)
            : response.purchaseOrders;
          dispatch(setPreviouslyReceived(filteredPOs));
          if (poNumber && filteredPOs.length > 0) {
            setSearchItemFound(true);
            setSearchedPOInSection(POSection.PreviouslyReceivedPO);
          }
        } else {
          dispatch(setPreviouslyReceived([]));
        }

        setLoading(false);
      })
      .catch((err) => {
        if (!err.__CANCEL__) {
          setApiHasError(true);
          dispatch(setPreviouslyReceived([]));
          setLoading(false);
        }
      });
  };

  const reload = () => {
    setVendorName('');
    setTotalCost('');
    setEta('');
    setPartialReceivedPOs([]);
    setSelectedReceivedDetailPO([]);
    dispatch(setSelectedPreviouslyReceivedId(''));
    dispatch(setSelectedPOToReceive({} as PurchaseOrder));
    dispatch(setUpdatedPOData([] as UpdatedPOInformation[]));
    dispatch(setPreviouslyReceived([]));
    fetchPurchaseOrders();
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fetchPurchaseOrders, []);

  useEffect(() => {
    if (reloadData) {
      reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadData]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(reload, [poNumber, fromDate, toDate]);

  useEffect(() => {
    setPreviouslyReceivedPOLoading(loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  useEffect(() => {
    if (!expanded) {
      setVendorName('');
      setTotalCost('');
      setEta('');
      setPartialReceivedPOs([]);
      setSelectedReceivedDetailPO([]);
      dispatch(setSelectedPreviouslyReceivedId(''));
    } else {
      dispatch(setSelectedPOToReceive({} as PurchaseOrder));
      dispatch(setUpdatedPOData([] as UpdatedPOInformation[]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);

  return (
    <div className={classes.purchaseOrderListWrapper}>
      <div
        className={classes.purchaseOrderList}
        data-testid={previouslyReceivedPOListTestId}
      >
        <div>
          <div className={classes.row}>
            <div className={classes.fixedFieldContainer}>
            <div className={classes.fieldWidth70percent}>
              <div className={classes.field}>
                <RACTextField
                  label={t('Vendor Name')}
                  type="text"
                  name="vendorName"
                  value={vendorName}
                  disabled
                />
              </div>
              <div className={classes.field}>
                <FieldWithTooltip
                  id="regularPOTotalCost"
                  currency
                  title={t('Total Cost of')}
                >
                  <AutoNumeric
                    name="regularPOTotalCost"
                    value={totalCost}
                    disabled
                  />
                </FieldWithTooltip>
              </div>
              <div className={classes.field}>
                <RACTextField
                  label={t('ETA')}
                  type="text"
                  name="eta"
                  value={eta}
                  disabled
                />
              </div>
              </div>
            </div>
            <div className={clsx(classes.field, classes.fieldFlex)}>
              <Icon classes={{ root: classes.icon }} onClick={reload}>
                <FontAwesomeIcon icon={faSync} />
              </Icon>
            </div>
          </div>
          <div>
            <div className={classes.scrollableContent}>
            <ApiStateWrapper
              loading={loading && purchaseOrders?.length === 0}
              hasApiError={hasApiError && purchaseOrders?.length === 0}
              response={purchaseOrders}
              successContent={
                <RACTable
                  renderTableHead={renderTableHead}
                  renderTableContent={renderTableContent}
                  stickyHeader
                />
              }
              classes={{
                loader: classes.contentHeight,
                apiError: classes.contentHeight,
                noItems: classes.contentHeight,
              }}
            />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
